import {fnLocalizeFilter, ILocale} from "../../../../services/localize.service";
import {IColumn} from "../../../UI/CustomTable/components/Columns/Columns";
import {IRow} from "../../../UI/CustomTable/components/Rows/Rows";
import {ISingleRow} from "../../../UI/CustomTable/interface/interface.custom";

interface IGetColumns {
    locale: ILocale;

    onDownloadFileExcel({row}: ISingleRow): void;
}

export const getColumns = ({locale, onDownloadFileExcel}: IGetColumns): IColumn[] => {

    return [{
        field: 'docNumber',
        label: fnLocalizeFilter(locale, '_lang.module.documents.certificates.table.number'),
        formatHeader: 'default',
        cell: {format: 'default'},
        align: 'center',
        alignData: 'center'
    }, {
        field: 'docDate',
        label: fnLocalizeFilter(locale, '_lang.module.common.filter.titleDate'),
        formatHeader: 'default',
        cell: {format: 'date-time'},
        align: 'center',
        alignData: 'center'
    }, {
        field: 'amount',
        label: fnLocalizeFilter(locale, '_lang.module.documents.certificates.table.sumWithPDV'),
        formatHeader: 'default',
        cell: {format: 'default'},
        align: 'center',
        alignData: 'center'
    }, {
        field: 'quantity',
        label: fnLocalizeFilter(locale, '_lang.module.documents.certificates.table.qty'),
        formatHeader: 'default',
        cell: {format: 'default'},
        align: 'center',
        alignData: 'center'
    }, {
        field: 'btn',
        label: '',
        formatHeader: 'default',
        cell: {format: 'icon-download', onDownloadFile: onDownloadFileExcel},
        align: 'center',
        alignData: 'center'
    }];
};
